import { useState } from "react";
import { Reveal, SectionTag, SectionTitle } from "./shared";

const TYPES = ["Apartment", "Plot", "Villa", "Commercial", "Resale"];
const ROWS = [
  ["Typical Budget", ["Rs 40 L - 2 Cr", "Rs 60 L - 3 Cr+", "Rs 1.5 Cr - 5 Cr+", "Rs 50 L - 3 Cr", "Varies, often below new"]],
  ["Typical Size", ["600 - 2,000 sq.ft", "100 - 500 sq.yd", "2,000 - 5,000 sq.ft", "200 - 1,000 sq.ft", "Same as asset type"]],
  ["Development Stage", ["New + ready options", "Developed sectors", "Select clusters", "Emerging", "Established"]],
  ["Rental Potential", ["Moderate, growing", "None until built", "Low yield, high lifestyle", "Footfall-driven", "Immediate if ready"]],
  ["Liquidity", ["Good in ready towers", "Strong land market", "Selective buyer pool", "Emerging market", "Depends on pricing"]],
  ["End Use", ["Ready living", "Custom build", "Premium living", "Business use", "Immediate use"]],
  ["Holding Period", ["3 - 7 years", "5 - 10 years", "Long-term", "5 - 10 years", "Flexible"]],
  ["Risk Considerations", ["Construction timelines", "Location within sector", "Ticket size", "Ecosystem maturity", "Title verification"]],
];

export function CompareSection() {
  const [selected, setSelected] = useState(["Apartment", "Plot"]);

  const toggle = (t) => {
    setSelected((prev) =>
      prev.includes(t) ? (prev.length > 1 ? prev.filter((x) => x !== t) : prev) : prev.length < 3 ? [...prev, t] : prev
    );
  };

  return (
    <section id="compare" className="relative py-28 lg:py-40 bg-[#0A0A0A]" data-testid="compare-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTag>Property Comparison</SectionTag>
        <div className="grid lg:grid-cols-2 gap-8 items-end mb-12">
          <SectionTitle>Compare Before <span className="text-gold-gradient italic">You Decide.</span></SectionTitle>
          <Reveal delay={0.15}>
            <div className="flex flex-wrap gap-2 lg:justify-end" data-testid="compare-type-picker">
              {TYPES.map((t) => (
                <button
                  key={t}
                  data-testid={`compare-type-${t.toLowerCase()}`}
                  onClick={() => toggle(t)}
                  className={`px-4 py-2 text-[10px] uppercase tracking-[0.2em] rounded-full border transition-colors ${
                    selected.includes(t) ? "border-[#D4AF37] text-[#F3E5AB] bg-[#D4AF37]/10" : "border-[#D4AF37]/15 text-[#71717A] hover:text-[#A1A1AA]"
                  }`}
                >
                  {t}
                </button>
              ))}
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="overflow-x-auto border border-[#D4AF37]/15 rounded-[2px] bg-[#0D0D0D]" data-testid="compare-matrix">
            <table className="w-full text-sm min-w-[680px]">
              <thead>
                <tr className="border-b border-[#D4AF37]/20">
                  <th className="text-left py-4 px-5 text-[10px] uppercase tracking-[0.2em] text-[#71717A] font-medium w-44">Criteria</th>
                  {selected.map((t) => (
                    <th key={t} className="text-left py-4 px-5 font-serif-lux text-xl text-[#F3E5AB] font-medium">{t}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {ROWS.map(([label, values]) => (
                  <tr key={label} className="border-b border-[#D4AF37]/8 hover:bg-[#D4AF37]/[0.03] transition-colors">
                    <td className="py-3.5 px-5 text-[10px] uppercase tracking-[0.18em] text-[#71717A]">{label}</td>
                    {selected.map((t) => (
                      <td key={t} className="py-3.5 px-5 text-[13px] text-[#A1A1AA]">{values[TYPES.indexOf(t)]}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 text-[11px] text-[#71717A] max-w-3xl leading-relaxed">
            An objective orientation framework, not a recommendation. Figures are indicative ranges;
            every shortlist should be stress-tested against live inventory and your holding strategy.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
